<template>
  <div class="visits-control-button">
    <standard-button
      class="go-back-button"
      class-type="secondary"
      text="Cofnij"
      @buttonClick="onButtonPrev()"
    />
    <div v-if="showPriceDisclaimer">
      <!-- eslint-disable -->
      <p class="price-disclaimer">
        Podane ceny są cenami rekomendowanymi brutto w PLN. Wszelkie informacje zawarte na Audi Online Service Booking należy traktować wyłącznie orientacyjnie, gdyż nie stanowią oferty w rozumieniu Kodeksu cywilnego i nie są wiążące. Ostateczną ofertę przedstawia wybrany przez Ciebie Preferowany Partner Serwisowy i to w umowie z nim zawartej następuje wiążące ustalenie ceny.
      </p>
      <!-- eslint-enable -->
    </div>
    <div
      class="step-indicator"
      v-if="isMobile"
    >
      <div
        class="indicate"
        :class="{
          'active': $route.path.includes('station'),
        }"
      />
      <div
        class="indicate"
        :class="{
          'active': $route.path.includes('service'),
        }"
      />
      <div
        class="indicate"
        :class="{
          'active': $route.path.includes('date'),
        }"
      />
      <div
        class="indicate"
        :class="{
          'active': $route.path.includes('confirm') && !$route.path.includes('confirmed'),
        }"
      />
    </div>
    <standard-button
      class="go-next-button"
      :text="buttonText"
      :loading="formLoading"
      @buttonClick="onButtonNext()"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    StandardButton,
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      chosenServices: 'carServices/chosenServices',
      chosenCar: 'car/getChosenCarSpecs',
      selectedPartner: 'visit/selectedPartner',
      selectedServices: 'visit/selectedServices',
      selectedVisitDate: 'visit/selectedVisitDate',
      showModal: 'modal/showModal',
      formLoading: 'visit/formLoading',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    buttonText() {
      const { path } = this.$route;
      if (path.includes('confirm') && !path.includes('edit')) {
        return 'Zarezerwuj wizytę';
      } if (path.includes('edit') && path.includes('confirm')) {
        return 'Edytuj wizytę';
      } if (this.isMobile) {
        return 'Dalej';
      }
      return 'Przejdź dalej';
    },
    showPriceDisclaimer() {
      return (this.$route.path.includes('service') || this.$route.path.includes('date'))
        && (this.$mq !== 'mobile' && this.$mq !== 'xs');
    },
    disabled() {
      const { path } = this.$route;
      const condition = path.includes('service') && (Array.isArray(this.selectedServices) && this.selectedServices.length);

      if (path.includes('station') && this.selectedPartner) {
        return false;
      }

      if (condition) {
        return false;
      }

      if (path.includes('date') && this.selectedVisitDate) {
        return false;
      }

      if (path.includes('confirm')) {
        return false;
      }

      return true;
    },
    carID() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return this.chosenCar.id;
    },
  },
  methods: {
    ...mapActions({
      setSelectedServices: 'visit/setSelectedServices',
      setSubmitTrigger: 'visit/setSubmitTrigger',
    }),
    onButtonNext() {
      const { path } = this.$route;

      if (path.includes('no_auth')) {
        if (path.includes('station')) {
          this.$router.push({ path: '/no_auth/visit/service' });
        }
        if (path.includes('service')) {
          this.$router.push({ path: '/no_auth/visit/date' });
        }
        if (path.includes('date')) {
          this.$router.push({ path: '/no_auth/visit/confirm' });
        }
        if (path.includes('confirm')) {
          this.setSubmitTrigger(true);
        }
      } else {
        if (path.includes('station')) {
          if (path.includes('edit')) {
            this.$router.push({ path: `/dashboard/visits/edit/${this.carID}/service` });
          } else {
            this.$router.push({ path: `/dashboard/visits/new/${this.carID}/service` });
          }
        }
        if (path.includes('service')) {
          if (path.includes('edit')) {
            this.$router.push({ path: `/dashboard/visits/edit/${this.carID}/date` });
          } else {
            this.$router.push({ path: `/dashboard/visits/new/${this.carID}/date` });
          }
        }
        if (path.includes('date')) {
          if (path.includes('edit')) {
            this.$router.push({ path: `/dashboard/visits/edit/${this.carID}/confirm` });
          } else {
            this.$router.push({ path: `/dashboard/visits/new/${this.carID}/confirm` });
          }
        }
        if (path.includes('confirm')) {
          this.setSubmitTrigger();
        }
      }
    },
    onButtonPrev() {
      const { path } = this.$route;

      if (path.includes('no_auth')) {
        if (path.includes('station')) {
          this.$router.push({ path: '/no_auth/visit/station' });
        }
        if (path.includes('service')) {
          this.$router.push({ path: '/no_auth/visit/station' });
        }
        if (path.includes('date')) {
          this.$router.push({ path: '/no_auth/visit/service' });
        }
        if (path.includes('confirm')) {
          this.$router.push({ path: '/no_auth/visit/date' });
        }
      } else {
        if (path.includes('station')) {
          this.$router.push({ path: '/dashboard/mycars' });
        }
        if (path.includes('service')) {
          if (path.includes('edit')) {
            this.$router.push({ path: `/dashboard/visits/edit/${this.carID}/station` });
          } else {
            this.$router.push({ path: `/dashboard/visits/new/${this.carID}/station` });
          }
        }
        if (path.includes('date')) {
          if (path.includes('edit')) {
            this.$router.push({ path: `/dashboard/visits/edit/${this.carID}/service` });
          } else {
            this.$router.push({ path: `/dashboard/visits/new/${this.carID}/service` });
          }
        }
        if (path.includes('confirm')) {
          if (path.includes('edit')) {
            this.$router.push({ path: `/dashboard/visits/edit/${this.carID}/date` });
          } else {
            this.$router.push({ path: `/dashboard/visits/new/${this.carID}/date` });
          }
        }
      }
    },
    handleKeyDown(event) {
      const { keyCode } = event;
      if (!this.showModal) {
        if (keyCode === 13 && !this.disabled) {
          this.onButtonNext();
        }
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
